
import { React, useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { LuShieldCheck } from "react-icons/lu";
import { BsStars } from "react-icons/bs";
import { MdPayments } from "react-icons/md";
import { PiChatsBold } from "react-icons/pi";
import { HiOutlineSparkles } from "react-icons/hi2";
import { FiUserCheck, FiTrendingUp, FiMenu, FiX, FiArrowUp, FiMapPin,
  FiPhoneCall,
  FiMail,
  FiChevronRight  } from "react-icons/fi";
  import { FaXTwitter } from "react-icons/fa6";
  import { FaFacebookF, FaTwitter, FaGooglePlusG, FaYoutube } from "react-icons/fa";
import { useAnalytics } from "../context/AnalyticsContext";

const WelcomePage = () => {
  const heroBackground = "/images/welcome/main_backg.jpg";
  const contentBackground = "/images/welcome/content-bg.jpg";
  const [journeyTab, setJourneyTab] = useState("client");
  const [isNavOpen, setIsNavOpen] = useState(false);

  const [showScrollTop, setShowScrollTop] = useState(false);

  const scrollRef = useRef(null);

  const { trackPageHit } = useAnalytics();


useEffect(() => {
  const node = scrollRef.current;

  const handleScroll = (source = "scroll") => {
    const winY =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    const containerY = node ? node.scrollTop : 0;
    const y = containerY || winY;

    setShowScrollTop(y > 200);

    console.log(
      "%c[Scroll Debug]",
      "color:#10b981;font-weight:bold;",
      {
        source,
        windowY: winY,
        containerY,
        showScrollTop: y > 200
      }
    );
  };

  window.addEventListener("scroll", () => handleScroll("window"), { passive: true });
  if (node) {
    node.addEventListener("scroll", () => handleScroll("container"), { passive: true });
  }

  handleScroll("initial");

  return () => {
    window.removeEventListener("scroll", () => handleScroll("window"));
    if (node) {
      node.removeEventListener("scroll", () => handleScroll("container"));
    }
  };
}, []);

useEffect(() => {
    if (typeof window !== "undefined") {
      trackPageHit("home");
    }
  }, [trackPageHit]);

  const handleScrollTop = () => {
    const node = scrollRef.current;

    if (node) {
      node.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };


  return (
    <div className="osh-page" ref={scrollRef}>

      <header className="osh-header">
        <div className="osh-header-left">
          <div className="osh-logo">
            {/* <span className="osh-logo-icon">💚</span> */}
            <span><img src="/images/logo_mini.png" alt="logo" width="53" height="48" /></span>
            <span className="osh-logo-text">
              <span className="osh-logo-main">ne Support</span>
              <span className="osh-logo-accent">Hub</span>
            </span>
          </div>

          <nav className={`osh-nav ${isNavOpen ? "open" : ""}`}>
            <a href="#why-osh" onClick={() => setIsNavOpen(false)}>Why OSH?</a>
            <a href="#services" onClick={() => setIsNavOpen(false)}>Services</a>
            <a href="#hiring-journey" onClick={() => setIsNavOpen(false)}>Hiring Journey</a>
            <a href="#maximized-value" onClick={() => setIsNavOpen(false)}>Maximized Value</a>
            <a href="#pricing" onClick={() => setIsNavOpen(false)}>Pricing</a>
            {/* <a href="#contact" onClick={() => setIsNavOpen(false)}>Contact</a> */}
          </nav>
        </div>

        <div className="osh-header-right">
          <div className="osh-phone">
            <div className="osh-phone-text">
              📞 1 (716) 302-1001
            </div>
          </div>

          <Link to="/login" state={{ userType: "client" }}>
            <button className="osh-btn-link">Login</button>
          </Link>
          <button
            type="button"
            className={`osh-nav-toggle ${isNavOpen ? "open" : ""}`}
            onClick={() => setIsNavOpen((prev) => !prev)}
          >
            {isNavOpen ? <FiX /> : <FiMenu />}
          </button>

        </div>
      </header>


      <main
        className="osh-hero"
      >
        <div className="osh-hero-overlay" />

        <div className="osh-hero-inner">
          <section className="osh-hero-content"
            style={{
              backgroundImage: "url('/images/welcome/content-bg3.jpg')",
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat"
            }}
          >

            <div className="content-text-wrapper">

              <h1 className="osh-hero-title">Caregiving, Support, Help</h1>

              <p className="osh-hero-subtitle">
                Connecting our community through trusted care and support.
                We have someone for all your needs, from specialized care, nursing
                and support to general household help.
              </p>
            </div>


            <div className="osh-hero-actions">
              <Link to="/register" state={{ userType: "client" }}>
                <button className="osh-btn-cta">Hire a Helper</button>
              </Link>
              <Link to="/register" state={{ userType: "worker" }}>
                <button className="osh-btn-secondary">Find Jobs</button>
              </Link>
            </div>
          </section>

          <section className="osh-content-carousel">
            <div className="carousel-content">
              <img src="/images/welcome/eldery-care2.jpg" alt="eldery-care" />
              <img src="/images/welcome/care-and-compassion2.jpg" alt="care-and-compassion" />
              <img src="/images/welcome/pet-grooming.jpg" alt="pet-grooming" />
              <img src="/images/welcome/cleaning-support.jpg" alt="cleaning-support" />
              <img src="/images/welcome/plumbing-support.jpg" alt="plumbing-support" />
              <img src="/images/welcome/digital-support.jpg" alt="digital-support" />
              <img src="/images/welcome/snow-plowing.jpg" alt="snow-plowing" />
              <img src="/images/welcome/mowing.jpg" alt="mowing" />
            </div>
          </section>

        </div>
      </main>

      {/* FEATURE STRIP */}
      <section className="osh-features">
        <div className="osh-feature">
          <LuShieldCheck className="osh-feature-icon" />

          <div className="feature-content-wrapper">
            <h3 className="osh-feature-title">Verified & Trusted Helpers</h3>
            <p className="osh-feature-text">Our Verified helpers are professionaly vetted and background-checked for safety.

            </p>
          </div>
        </div>

        <span className="osh-feature-divider" />

        <div className="osh-feature">
          <BsStars className="osh-feature-icon" />
          <div className="feature-content-wrapper">
            <h3 className="osh-feature-title">Smart Matching & Engagement</h3>
            <p className="osh-feature-text">Match, chat, manage agreements and timesheets, and more. All in one place.</p>
          </div>
        </div>

        <span className="osh-feature-divider" />

        <div className="osh-feature">
          <MdPayments className="osh-feature-icon" />
          <div className="feature-content-wrapper">
            <h3 className="osh-feature-title">Secure & Cashless Payments</h3>
            <p className="osh-feature-text">All transactions are securely processed by <strong>Stripe</strong> for fast and reliable payments.</p>
          </div>
        </div>

        <span className="osh-feature-divider" />

        <div className="osh-feature">
          <PiChatsBold className="osh-feature-icon" />
          <div className="feature-content-wrapper">
            <h3 className="osh-feature-title">Real-Time Support & Updates</h3>
            <p className="osh-feature-text">Get instant notifications, chat in real time, and track service progress inside the app.</p>
          </div>
        </div>
      </section>

      <h3 className="osh-footer-title"></h3>
            

      {/* ABOUT OSH SECTION */}
      <section className="why-osh-section" id="why-osh">
        <div className="osh-services-heading">
          <p className="osh-section-kicker">
            <HiOutlineSparkles className="osh-kicker-icon" />
            WHY OSH?
          </p>
          <h2 className="why-osh-title">
            Your Single Hub for Seamless Daily Support
          </h2>

          <p className="why-osh-sub">
              One Support Hub <strong>( OSH )</strong> securely connects families, individuals, and businesses with
              trusted helpers for essential needs, including <strong>professional caregiving, nursing, specialized childcare (nanny/babysitting),
              household support, pet care, home
              maintenance</strong>, and more. The platform simplifies the entire hiring journey, automating everything from <strong>Job posting, 
              matching, video meet and greet to agreements, Timesheets generation, invoicing</strong> and <strong>payment approval</strong>. All within one simple, 
              secure dashboard.
            </p>
            {/* <p className="why-osh-sub">
              The platform simplifies the entire hiring journey, automating everything from job posting, 
              matching, and agreements to Timesheet, invoice, and payment approval. All within one simple, 
              secure dashboard.
            </p> */}
        </div>
        </section>

      {/* SERVICES SECTION */}
      {/* OSH SERVICES – CATEGORY OVERVIEW */}
      <section className="osh-services" id="services">
        <div className="osh-services-heading">
          <p className="osh-section-kicker">
            <HiOutlineSparkles className="osh-kicker-icon" />
            SERVICES
          </p>
          <h2 className="osh-services-title">
            Explore Our Full Service Range
          </h2>
          <p className="osh-services-sub">
            Get reliable help across every category: professional Caregiving & Nursing, dedicated Childcare, expert Home Maintenance, responsive Technical Support, and much more.
          </p>
        </div>

        <div className="osh-services-grid">
          {/* CARE & PERSONAL SUPPORT */}
          <article className="osh-services-category">
            <div className="osh-category-media">
              <img
                src="/images/welcome/care-support.jpg"
                alt="Care & Personal Support"
                className="osh-category-image"
              />
            </div>

            <div className="osh-category-header">
              <div className="osh-category-badge">💚</div>
              <h3 className="osh-category-title">Caregiving & Personal Support</h3>
            </div>
            <ul className="osh-category-list">
              <li>Elder care & companionship</li>
              <li>Disability & mobility support</li>
              <li>Telehealth & digital health setup</li>
              <li>Mental wellness & peer support</li>
            </ul>
            <button className="osh-category-cta">
              <span className="view-more-text">View More</span>
              <span className="view-more-arrow">➤</span>
            </button>
          </article>

          {/*  PETS & LIFESTYLE SUPPORT */}
          <article className="osh-services-category">
            <div className="osh-category-media">
              <img
                src="/images/welcome/lifestyle-support.jpg"
                alt="Pets & Lifestyle Support"
                className="osh-category-image"
              />
            </div>

            <div className="osh-category-header">
              <div className="osh-category-badge">🐾</div>
              <h3 className="osh-category-title">Pets & Lifestyle Support</h3>
            </div>
            <ul className="osh-category-list">
              <li>Pet sitting, walking & grooming</li>
              <li>Errands & personal assistance</li>
              <li>Meal prep & nutrition assistance</li>
              <li>Vehicle care & detailing</li>
              
            </ul>
            <button className="osh-category-cta">
              <span className="view-more-text">View More</span>
              <span className="view-more-arrow">➤</span>
            </button>
          </article>

          {/*  PROFESSIONAL & ADMIN SUPPORT */}
          <article className="osh-services-category">
            <div className="osh-category-media">
              <img
                src="/images/welcome/admin-support.jpg"
                alt="Professional & Admin Support"
                className="osh-category-image"
              />
            </div>

            <div className="osh-category-header">
              <div className="osh-category-badge">📂</div>
              <h3 className="osh-category-title">Professional & Admin Support</h3>
            </div>
            <ul className="osh-category-list">
              <li>Form & document assistance</li>
              <li>Government benefits support</li>
              <li>Appointment booking & coordination</li>
              <li>Digital admin & organization</li>
            </ul>
            <button className="osh-category-cta">
              <span className="view-more-text">View More</span>
              <span className="view-more-arrow">➤</span>
            </button>
          </article>

          {/*  HOME MAINTENANCE & REPAIRS */}
          <article className="osh-services-category">
            <div className="osh-category-media">
              <img
                src="/images/welcome/property-maintenance.jpg"
                alt="Home Maintenance & Repairs"
                className="osh-category-image"
              />
            </div>

            <div className="osh-category-header">
              <div className="osh-category-badge">🏡</div>
              <h3 className="osh-category-title">Property Maintenance & Repairs</h3>
            </div>
            <ul className="osh-category-list">
              <li>Cleaning & deep refresh</li>
              <li>Plumbing & water systems</li>
              <li>Electrical & smart wiring</li>
              <li>Carpentry & adaptations</li>
            </ul>
            <button className="osh-category-cta">
              <span className="view-more-text">View More</span>
              <span className="view-more-arrow">➤</span>
            </button>
          </article>

          {/* TECH & SMART HOME HELP */}
          <article className="osh-services-category">
            <div className="osh-category-media">
              <img
                src="/images/welcome/home-tech.jpg"
                alt="Tech & Smart Home Help"
                className="osh-category-image"
              />
            </div>

            <div className="osh-category-header">
              <div className="osh-category-badge">📱</div>
              <h3 className="osh-category-title">Tech & Smart Home Help</h3>
            </div>
            <ul className="osh-category-list">
              <li>Smart home setup & troubleshooting</li>
              <li>Home office & Wi-Fi optimization</li>
              <li>Digital & IT services</li>
              <li>Device & Computer Support</li>
            </ul>
            <button className="osh-category-cta">
              <span className="view-more-text">View More</span>
              <span className="view-more-arrow">➤</span>
            </button>
          </article>

          {/* SAFETY & GREEN HOME UPGRADES */}
          <article className="osh-services-category">
            <div className="osh-category-media">
              <img
                src="/images/welcome/home-safety.jpg"
                alt="Safety & Green Home Upgrades"
                className="osh-category-image"
              />
            </div>

            <div className="osh-category-header">
              <div className="osh-category-badge">🌱</div>
              <h3 className="osh-category-title">Home Safety, Sustainability & Readiness</h3>
            </div>
            <ul className="osh-category-list">
              <li>Green energy & insulation upgrades</li>
              <li>Solar & efficiency checkups</li>
              <li>Pest safety (child & pet friendly)</li>
              <li>Home safety & preparedness</li>
            </ul>
            <button className="osh-category-cta">
              <span className="view-more-text">View More</span>
              <span className="view-more-arrow">➤</span>
            </button>
          </article>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="osh-how" id="hiring-journey">
        <div className="osh-how-header">
          <p className="osh-section-kicker">
            <HiOutlineSparkles className="osh-kicker-icon" />
            CLIENT AND HELPER JOURNEY
          </p>
          <h2 className="osh-how-title">
            Seamless Service Process
          </h2>
          <p className="osh-how-sub">
            OSH platform provides a smooth integrated experience: matching, messaging, video meet, automated agreements and timesheets, secure payments, real-time updates, and more.
          </p>
        </div>

        <div className="osh-how-tabs">
          <button
            type="button"
            className={`osh-how-tab ${journeyTab === "client" ? "active" : ""}`}
            onClick={() => setJourneyTab("client")}
          >
            Hiring Helpers
          </button>
          <button
            type="button"
            className={`osh-how-tab ${journeyTab === "worker" ? "active" : ""}`}
            onClick={() => setJourneyTab("worker")}
          >
            Looking for jobs
          </button>
        </div>

        <div className="osh-how-grid">
          {/* 1 */}
          {journeyTab === "client" ? (
            <>
              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">1</div>
                  <h3 className="osh-how-step-title">Create & verify your account</h3>
                </div>
                <p className="osh-how-step-text">
                  Sign up, verify your email, and add basic personal details and emergency contacts so helpers
                  understand who they’ll be supporting.
                </p>
              </article>

              {/* 2 */}
              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">2</div>
                  <h3 className="osh-how-step-title">Complete profile & payment setup</h3>
                </div>
                <p className="osh-how-step-text">
                  Add your support needs, locations, and preferences, then securely set up your payment method via <strong>Stripe</strong> for secure and reliable payment processing. <strong>We never store any financial information;</strong> instead, we use Stripe’s secure token to process payments upon service completion.
                </p>
              </article>

              {/* 3 */}
              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">3</div>
                  <h3 className="osh-how-step-title">Create a job with your needs</h3>
                </div>
                <p className="osh-how-step-text">
                  Describe the help you need: locations, support areas, activities like showering or medication
                  reminders, schedule, and any special notes. Each conversation with a helper is tied to a specific job.
                </p>
              </article>

              {/* 4 */}
              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">4</div>
                  <h3 className="osh-how-step-title">Find & shortlist helpers</h3>
                </div>
                <p className="osh-how-step-text">
                  Browse matching helpers based on your job, location, and preferences (including helper gender if you choose).
                  View profiles, shortlist favorites, and decide who you’d like to speak with.
                </p>
              </article>

              {/* 5 */}
              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">5</div>
                  <h3 className="osh-how-step-title">Chat & meet on video</h3>
                </div>
                <p className="osh-how-step-text">
                  Message your selected helper about the job, then move to a meet-and-greet video session. All inside
                  OneSupportHub. No external apps or tools required.
                </p>
              </article>

              {/* 6 */}
              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">6</div>
                  <h3 className="osh-how-step-title">Agreement created & signed</h3>
                </div>
                <p className="osh-how-step-text">
                  When you’re both happy, the helper sends an agreement automatically built from your job details.
                  You review, request changes if needed, and sign. Once both have signed, the agreement becomes active.
                </p>
              </article>

              {/* 7 */}
              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">7</div>
                  <h3 className="osh-how-step-title">Sessions & progress tracking</h3>
                </div>
                <p className="osh-how-step-text">
                  The helper requests each session start through the app, you approve or decline, and both can see
                  progress. After each session, the helper submits completion and you confirm it. The app provides continuous status updates
                  and notifications at every step.
                </p>
              </article>

              {/* 8 */}
              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">8</div>
                  <h3 className="osh-how-step-title">Timesheets, claims & payment</h3>
                </div>
                <p className="osh-how-step-text">
                  When the work is done, a timesheet and claim invoice are created from the agreement. You review and
                  approve. After approval, <strong>Stripe securely processes payments through the payment method you’ve provided to their trusted system.</strong> The helper gets paid, and
                  all records live in your Timesheets & Billing dashboard for easy reference.
                </p>
              </article>
            </>
          ) : (
            <>
              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">1</div>
                  <h3 className="osh-how-step-title">Sign up & verify your account</h3>
                </div>
                <p className="osh-how-step-text">
                  Create a worker account, verify your email, and confirm your basic
                  details so clients know who they&apos;re working with.
                </p>
              </article>

              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">2</div>
                  <h3 className="osh-how-step-title">
                    Complete your helper profile
                  </h3>
                </div>
                <p className="osh-how-step-text">
                  Add your availability, service locations, rates, work experience,
                  employment history, training, education, and certifications and a
                  clear profile photo.
                </p>
              </article>

              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">3</div>
                  <h3 className="osh-how-step-title">
                    Set up payment details & badges
                  </h3>
                </div>
                <p className="osh-how-step-text">
                  Securely add your payment details to Stripe to receive funds for your delivered services
                  and choose to complete an optional background check to earn a <strong>Verified</strong> badge,
                  increasing visibility and trust on your profile.
                </p>
              </article>

              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">4</div>
                  <h3 className="osh-how-step-title">Browse and match to jobs</h3>
                </div>
                <p className="osh-how-step-text">
                  Once your profile is complete, start browsing posted jobs that match
                  your skills, locations, and availability. Save favorites or apply
                  directly to opportunities that fit you.
                </p>
              </article>

              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">5</div>
                  <h3 className="osh-how-step-title">
                    Chat, meet & agree on terms
                  </h3>
                </div>
                <p className="osh-how-step-text">
                  When a client is interested, you&apos;ll chat inside the app, join a
                  meet-and-greet video session, and then send an agreement generated
                  automatically from the job details.
                </p>
              </article>

              <article className="osh-how-step">
                <div className="osh-how-step-header">
                  <div className="osh-how-step-number">6</div>
                  <h3 className="osh-how-step-title">
                    Deliver sessions & get paid
                  </h3>
                </div>
                <p className="osh-how-step-text">
                  Use the app to request session starts, log completed visits, and
                  submit timesheets and claim invoices. Once the client approves,
                  Stripe processes payment and your earnings appear in your
                  Timesheets &amp; Billing dashboard.
                </p>
              </article>
            </>
          )}
        </div>
      </section>

      {/* MAXIMIZED VALUE SECTION */}
      <section className="osh-value" id="maximized-value">
        <div className="osh-value-header">
          <p className="osh-section-kicker">
            <HiOutlineSparkles className="osh-kicker-icon" />
            MAXIMIZED VALUE
          </p>
          <h2 className="osh-value-title">
            Where clients save and helpers thrive
          </h2>
          <p className="osh-value-sub">
            Our platform is designed so clients pay fair, transparent fees while
            helpers keep most of what they earn. Our platform fee is modest, our
            structure is simple, and all payments are processed securely by <strong>Stripe</strong>.
          </p>
        </div>

        <div className="osh-value-grid">
          {/* CLIENT VALUE CARD */}
          <article className="osh-value-card">
            <div className="osh-value-card-header">
              <div className="osh-value-icon">
                <FiUserCheck />
              </div>
              <h3 className="osh-value-card-title">For clients</h3>
            </div>

            <ul className="osh-value-list">
              <li>
                The agreed-upon price is your final charge. No add-on hidden fees or surcharges.
              </li>
              <li>
                Signing up and initiating the hiring process is completely free.
              </li>
              <li>
                The full cost is clearly shown in the agreement before signing.
              </li>
              <li>
                Payment is only processed upon successful service completion and your final approval.
              </li>
              <li>
                Centralized dashboard for all jobs, agreements, timesheets, invoices and payment records.
              </li>
            </ul>


          </article>

          <article className="osh-value-card osh-value-card-highlight">
            <div className="osh-value-card-header">
              <div className="osh-value-icon">
                <FiTrendingUp />
              </div>
              <h3 className="osh-value-card-title">For helpers</h3>
            </div>

            <ul className="osh-value-list">
              <li>
                Set your own rates based on your experience, training, and the type of support you offer.
              </li>
              <li>
                Signing up and initiating the hiring process is completely free.
              </li>
              <li>
                The full service cost is shown clearly in the agreement before you confirm and sign.
              </li>
              <li>
                A modest platform fee and Stripe costs are deducted. The rest goes to you.
              </li>
              <li>
                Centralized dashboard for all job applications, agreements, timesheets, invoices and payment records.
              </li>
            </ul>
          </article>
        </div>
      </section>


      {/* PRICING SECTION */}
      <section className="osh-pricing" id="pricing">
        <div className="osh-pricing-header">
          <p className="osh-section-kicker">
            <HiOutlineSparkles className="osh-kicker-icon" />
            PLANS & PRICING
          </p>

          <h2 className="osh-pricing-title">
            Choose a plan that fits your needs
          </h2>
          <p className="osh-pricing-sub">
            Start free, then upgrade anytime for more searches, more jobs, and
            greater flexibility.
          </p>
        </div>

        <div className="osh-pricing-grid">
          {/* FREE / STARTER */}
          <article className="osh-pricing-card">
            <h3 className="osh-pricing-name">Starter</h3>
            <p className="osh-pricing-note">A free plan with everything you need to get started.</p>

            <div className="osh-pricing-price">
              <span className="osh-pricing-amount">$0</span>
              <span className="osh-pricing-period">/ month</span>
            </div>
            <p className="osh-pricing-billing">
              No Purchase Required.
            </p>
            <ul className="osh-pricing-features">
              <li>Search helpers within <strong>10 miles</strong></li>
              <li>Up to <strong>5</strong> helper searches per day</li>
              <li><strong>1</strong> active job at a time</li>
              <li>Message helpers after creating a job</li>
              <li><strong>1</strong> meet-and-greet video per month</li>
              <li>Progress tracking & notifications</li>
            </ul>

            <button className="osh-pricing-cta">Get started free</button>
          </article>

          {/* STANDARD / PLUS – HIGHLIGHTED */}
          <article className="osh-pricing-card osh-pricing-card-featured">
            <div className="osh-pricing-pill">Most popular</div>

            <h3 className="osh-pricing-name">Plus</h3>
            <p className="osh-pricing-note">For families and ongoing support.</p>

            <div className="osh-pricing-price">
              <span className="osh-pricing-amount">$49.99</span>
              <span className="osh-pricing-period">/ Year</span>
            </div>

            <p className="osh-pricing-billing">
              Or pay <span className="monthly-pay-text">$5.99 monthly</span>. Cancel anytime.
            </p>

            <ul className="osh-pricing-features">
              <li>Search helpers within <strong>30 miles</strong></li>
              <li>Unlimited helper searches</li>
              <li>Up to <strong>5</strong> active jobs at once</li>
              <li>Unlimited messaging & video</li>
              <li>Priority matching & better helper suggestions</li>
              <li>Progress tracking & notifications</li>
            </ul>

            <button className="osh-pricing-cta osh-pricing-cta-featured">
              Choose Plus
            </button>
          </article>

          {/* PREMIUM / PRO */}
          <article className="osh-pricing-card">
            <h3 className="osh-pricing-name">Premium</h3>
            <p className="osh-pricing-note">For heavy users & multi-location needs.</p>

            <div className="osh-pricing-price">
              <span className="osh-pricing-amount">$99.99</span>
              <span className="osh-pricing-period">/ Year</span>
            </div>
            <p className="osh-pricing-billing">
              Or pay <span className="monthly-pay-text">$11.99 monthly</span>. Cancel anytime.
            </p>

            <ul className="osh-pricing-features">
              <li><strong>Unlimited</strong> search radius</li>
              <li><strong>Unlimited</strong> helper searches & active jobs</li>
              <li>Support for multiple locations</li>
              <li>Family / team access to monitor progress</li>
              <li>Priority support and faster responses</li>
              <li>Advanced scheduling, insights & history</li>
            </ul>

            <button className="osh-pricing-cta">Choose Premium</button>
          </article>
        </div>

        <p className="osh-pricing-footnote">
          All payments are handled securely by <strong>Stripe</strong>, our trusted processing partner.
        </p>
      </section>



      {/* TRUSTED BY SECTION */}
      {/* <section className="osh-trusted">
        <h2 className="osh-trusted-heading">
          Our trusted partners
        </h2>

        <div className="osh-trusted-logos">
          <img
            src="/images/welcome/cli-lo.png"
            alt="DemoX"
            className="osh-brand-logo"
          />
          <img
            src="/images/welcome/cli-lo1.png"
            alt="Recharge"
            className="osh-brand-logo"
          />
          <img
            src="/images/welcome/cli-lo2.png"
            alt="Lorem Ipsum"
            className="osh-brand-logo"
          />
          <img
            src="/images/welcome/Recharge-color.png"
            alt="Online"
            className="osh-brand-logo"
          />
          <img
            src="/images/welcome/cli-lo.png"
            alt="DemoX"
            className="osh-brand-logo"
          />
        </div>
      </section> */}
      <footer className="osh-footer" id="explore">
        <div className="osh-footer-inner">
          <div className="osh-footer-column osh-footer-about">
            <h3 className="osh-footer-title">One Support Hub</h3>
            <p className="osh-footer-about-text">
              Connecting you to trusted Caregiving, Nursing, Personal Support, Home Maintenance, 
              and General Household Help. All in one secure hub.
            </p>
            {/* <p className="osh-footer-about-text">
              The platform simplifies the entire hiring journey, automating everything from job posting, 
              matching, and agreements to Timesheet, invoice, and payment approval. All within one simple, 
              secure dashboard.
            </p> */}

            <div className="osh-footer-socials">
              <button className="osh-footer-social-btn" aria-label="Facebook">
                <FaFacebookF />
              </button>
              <button className="osh-footer-social-btn" aria-label="Twitter">
                <FaXTwitter />
              </button>
              {/* <button className="osh-footer-social-btn" aria-label="Google Plus">
                <FaGooglePlusG />
              </button>
              <button className="osh-footer-social-btn" aria-label="YouTube">
                <FaYoutube />
              </button> */}
            </div>
          </div>
          <div className="osh-footer-column">
            <h3 className="osh-footer-title">Explore More</h3>
            <ul className="osh-footer-links">
              <li>
                <FiChevronRight className="osh-footer-link-icon" />
                <a href="#">About Us</a>
              </li>
              <li>
                <FiChevronRight className="osh-footer-link-icon" />
                <a href="#">Events</a>
              </li>
              <li>
                <FiChevronRight className="osh-footer-link-icon" />
                <a href="#">Terms and Policies</a>
              </li>
              <li>
                <FiChevronRight className="osh-footer-link-icon" />
                <a href="#">Feedback</a>
              </li>
              {/* <li>
                <FiChevronRight className="osh-footer-link-icon" />
                <a href="#pricing">Blog</a>
              </li>
              <li>
                <FiChevronRight className="osh-footer-link-icon" />
                <a href="#maximized-value">Contact</a>
              </li> */}
            </ul>
          </div>

          <div className="osh-footer-column osh-footer-contact">
            <div className="osh-footer-contact-item">
              <div className="osh-footer-contact-icon">
                <FiMapPin />
              </div>
              <div className="osh-footer-contact-text">
                <p>1671, FairField, IA</p>
                <p>52556 USA</p>
              </div>
            </div>

            <div className="osh-footer-contact-item">
              <div className="osh-footer-contact-icon">
                <FiPhoneCall />
              </div>
              <div className="osh-footer-contact-text">
                <p>1 (716) 302-1001</p>
              </div>
            </div>

            <div className="osh-footer-contact-item">
              <div className="osh-footer-contact-icon">
                <FiMail />
              </div>
              <div className="osh-footer-contact-text">
                <p>info@onesupporthub.com</p>
              </div>
            </div>
          </div>
        </div>

        <div className="osh-footer-bottom">
          <span>
            © {new Date().getFullYear()} One Support Hub. All rights reserved.
          </span>
        </div>
      </footer>
      {showScrollTop && (
  <button
    type="button"
    className="osh-scroll-top-btn"
    onClick={handleScrollTop}
    aria-label="Scroll to top"
  >
     <FiArrowUp/>
  </button>
)}

    </div>
  );
};

export default WelcomePage;

